module.exports = "<!--\n    disabled = {true}\n-->\n<editor\n[(ngModel)]=\"texto\"\ninitialValue={details}\n[init]=\"init\"\n ></editor>"


//////////////////
// WEBPACK FOOTER
// ./src/app/examples/tinymce/tinymce.component.html
// module id = ./src/app/examples/tinymce/tinymce.component.html
// module chunks = main